import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as handlers from "../constants/handlers";

export const getBatchesByColorant = (colorantId) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_BATCHES_BY_COLORANT,
        params: {
            colorantId: colorantId
        }
    },
    method: handlers.GET_BATCHES_BY_COLORANT,
    tabId: 0
});

export const performInitCheck = () => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_ALL_COLORANT_BATCHES
    },
    method: handlers.GET_ALL_COLORANT_BATCHES,
    tabId: 0
});
